import baseCharts from '../../../charts'
import { GLYPH_COUNT, glyphNameAt } from './ChartGlyph'

/**
 * Every registered chart, in registry order, paired with the index of the
 * vector glyph that depicts it. Names come from each chart's own metadata, so
 * the homepage cannot advertise a chart the builder does not offer, or
 * miscount them.
 *
 * The pairing is positional, which is what keeps the labels in sync for free —
 * but it also means a reorder or insertion upstream would silently show the
 * wrong picture, so mismatches are reported in development.
 */
export function getChartGlyphs() {
  const glyphs = baseCharts
    .map((chart, index) => ({
      key: chart?.metadata?.id || `chart-${index}`,
      name: chart?.metadata?.name || '',
      index,
      hasGlyph: index < GLYPH_COUNT,
    }))
    .filter((glyph) => glyph.name)

  if (process.env.NODE_ENV !== 'production') {
    if (baseCharts.length > GLYPH_COUNT) {
      window.console.warn(
        `chartGlyphs: ${baseCharts.length} charts are registered but only ` +
          `${GLYPH_COUNT} glyphs are drawn. Add the missing ones to ` +
          'ChartGlyph.js, or the extras render without a picture.'
      )
    }
    glyphs.forEach((glyph) => {
      const drawn = glyphNameAt(glyph.index)
      if (drawn && drawn !== glyph.name) {
        window.console.warn(
          `chartGlyphs: registry position ${glyph.index} is "${glyph.name}" ` +
            `but the glyph drawn there is "${drawn}". The glyph order in ` +
            'ChartGlyph.js needs to match src/charts.js.'
        )
      }
    })
  }

  return glyphs
}
